import baseAPI from './baseAPI';

export interface SendVerificationCodeRequest {
  email: string;
}

export interface VerifyEmailCodeRequest {
  email: string;
  code: string;
}

export interface ResetPasswordRequest {
  email: string;
  newPassword: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
  data?: Record<string, unknown>;
}

export const forgotPasswordAPI = {
  // 이메일 인증 코드 발송
  sendVerificationCode: async (data: SendVerificationCodeRequest): Promise<ForgotPasswordResponse> => {
    try {
      const response = await baseAPI.post('/auth/send-verification-code', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 이메일 인증 코드 검증
  verifyEmailCode: async (data: VerifyEmailCodeRequest): Promise<ForgotPasswordResponse> => {
    try {
      const response = await baseAPI.post('/auth/verify-email-code', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 비밀번호 재설정
  resetPassword: async (data: ResetPasswordRequest): Promise<ForgotPasswordResponse> => {
    try {
      const response = await baseAPI.post('/auth/reset-password', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
